var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breads),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }